import { gql, useMutation } from "@apollo/client";

const MUTATION = gql`
  mutation LeaveEscape($id: ID!) {
    leaveEscape(id: $id) {
      removed
    }
  }
`;

interface DataType {
  leaveEscape: {
    removed?: boolean;
  };
}

interface VariablesType {
  id: string;
}

export default function useLeaveEscape() {
  return useMutation<DataType, VariablesType>(MUTATION);
}
